<script setup lang="ts">
import FlashCardDeck from '~/components/flashcards/FlashCardDeck.vue'

defineProps<{
  locationId: number
}>()
</script>

<template>
  <FlashCardDeck
    :location-id
    class="not-prose"
  />
</template>
